export class UploadErrorEvent {
    constructor({ error }) {
        this.name = 'error';
        this.error = error;
    }
    get data() {
        return {
            error: this.error,
        };
    }
}
